import { useState } from 'react';

import type { ModalProps } from '~features/userInfo/model/types';
import { useSession } from '~hooks/useSession';
import { userApi } from '~services/api/user';
import { Loader } from '~shared/ui/atoms/Loader';
import { isSafeApp } from '~shared/utils/host';

import { Wrapper } from '../Wrapper';

const toInputDate = (iso: string) => iso.split('T')[0];

export const Content = ({ onClose }: ModalProps) => {
	const { userId } = useSession();
	const [birthday, setBirthday] = useState<string | null>(null);
	const { data: infoData, isSuccess: infoIsSuccess } = userApi.useUserInfoQuery(
		{ id: userId },
		{
			skip: !userId,
			selectFromResult: (e) => {
				if (e.data?.birthday && !birthday) {
					setBirthday(toInputDate(e.data?.birthday ?? ''));
				}
				return e;
			},
		}
	);
	const { data: preferencesData, isSuccess: preferencesIsSuccess } =
		userApi.useUserProfilePreferencesQuery({ userId }, { skip: !userId });
	const { data: profileData, isSuccess: profileIsSuccess } =
		userApi.useUserProfileQuery({ userId }, { skip: !userId });
	const { data: kinksData, isSuccess: kinksIsSuccess } =
		userApi.useUserKinksQuery({ userId }, { skip: !userId });

	if (
		!infoIsSuccess ||
		!preferencesIsSuccess ||
		!profileIsSuccess ||
		!kinksIsSuccess
	) {
		return <Loader />;
	}

	return (
		<Wrapper
			onClose={onClose}
			defaultValues={{
				nickname: profileData.nick,
				bio: profileData.bio || '',
				name: infoData.name,
				birthday: birthday || '',
				isNSFW: !isSafeApp,
				gender: infoData.gender,
				into: preferencesData.preferences.genders || [],
				ageMin: preferencesData.preferences.ageMin || 18,
				ageMax: preferencesData.preferences.ageMax || 65,
				kinks: preferencesData.preferences.kinks || [],
			}}
			kinks={kinksData.kinks}
		/>
	);
};
